import { ModelMappingModelPurpose } from '@/types/schema';

export interface ModelPurposeDetails {
  label: string;
  recommendedModel: string;
}

export type ModelPurpose = `${ModelMappingModelPurpose}`;

// Keep the recommended models synchronized with Platform's model_resolver.go.
export const MODEL_PURPOSE_DETAILS: Record<ModelPurpose, ModelPurposeDetails> =
  {
    [ModelMappingModelPurpose.QuickSummary]: {
      label: 'Quick Summary',
      recommendedModel: 'gpt-4o',
    },
    [ModelMappingModelPurpose.Mini]: {
      label: 'Mini',
      recommendedModel: 'gpt-4.1-mini',
    },
    [ModelMappingModelPurpose.AdvancedReasoning]: {
      label: 'Advanced Reasoning',
      recommendedModel: 'gpt-6.1-sol',
    },
    [ModelMappingModelPurpose.DocumentSummaryStandard]: {
      label: 'Document Summary (Standard)',
      recommendedModel: 'gpt-6.1-sol',
    },
    [ModelMappingModelPurpose.DocumentSummaryHigh]: {
      label: 'Document Summary (High)',
      recommendedModel: 'gpt-5',
    },
    [ModelMappingModelPurpose.LongContext]: {
      label: 'Long Context',
      recommendedModel: 'gpt-4.1',
    },
    [ModelMappingModelPurpose.ReasoningMini]: {
      label: 'Reasoning Mini',
      recommendedModel: 'gpt-5.6-luna',
    },
    [ModelMappingModelPurpose.ReasoningMax]: {
      label: 'Reasoning Max',
      recommendedModel: 'gpt-6.1-sol',
    },
    [ModelMappingModelPurpose.ReasoningStandard]: {
      label: 'Reasoning Standard',
      recommendedModel: 'gpt-5.6-terra',
    },
    [ModelMappingModelPurpose.KgReasoning]: {
      label: 'KG Reasoning',
      recommendedModel: 'gpt-5.6-luna',
    },
    [ModelMappingModelPurpose.EvidenceSearch]: {
      label: 'Evidence Search',
      recommendedModel: 'gpt-5.6-luna',
    },
    [ModelMappingModelPurpose.Fast]: {
      label: 'Fast',
      recommendedModel: 'gpt-5.4-nano',
    },
  };
